module.exports = __webpack_public_path__ + "static/media/tail-right.cf4ed993.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tail-right.svg
// module id = 64
// module chunks = 0